module.exports = __webpack_public_path__ + "eccc0c2a6c6ed1891958088715d0334e.png";